__turbopack_context__.v({
  "actionButton": "base-module-scss-module__dQ-xYa__actionButton",
  "mdContainer": "base-module-scss-module__dQ-xYa__mdContainer",
  "secondaryBtn": "base-module-scss-module__dQ-xYa__secondaryBtn",
  "sectionDescription": "base-module-scss-module__dQ-xYa__sectionDescription",
  "sectionTitle": "base-module-scss-module__dQ-xYa__sectionTitle",
});
